import { visitorList, visitorDetails } from "constants/visitor";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

//get visitor list
export const getVisitorList = async (dispatch, pageNum, searchString) => {
  try {
    const res = await api.visitor_list(pageNum, searchString);
    dispatch({ type: visitorList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: visitorList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getVisitorsByID = async (dispatch, id, pageNum, searchString) => {
  try {
    const res = await api.get_visitor_by_Id(id, pageNum, searchString);
    dispatch({ type: visitorDetails, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: visitorDetails,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
